// ** React Imports
import { lazy } from 'react'

const MrstaUserList = lazy(() => import('../../views/mrsta-user/list'))
const MrstaUserView = lazy(() => import('../../views/mrsta-user/view'))
const MrstaUserEdit = lazy(() => import('../../views/mrsta-user/edit'))
const MrstaUserChangePassword = lazy(() => import('../../views/mrsta-user/change-password'))

const MrstaUserRoutes = [
  {
    element: <MrstaUserList />,
    path: '/mrsta-user/list'
  },
  {
    element: <MrstaUserView />,
    path: '/mrsta-user/view/:id'
  },
  {
    element: <MrstaUserEdit />,
    path: '/mrsta-user/edit/:id'
  },
  {
    element: <MrstaUserChangePassword />,
    path: '/mrsta-user/change-password/:id'
  }
]

export default MrstaUserRoutes
